/* eslint-disable react/jsx-max-props-per-line */

import PropTypes from 'prop-types';
import React, { Component, Suspense } from 'react';
import AppLoading from '../Loading/AppLoading';
import { Switch, Route } from 'react-router-dom';
import { ROUTES } from 'config/constants';
import { UnauthedRoute, AuthedRoute } from './components/RouteWrappers';
import {
    ContentListContainer,
    PersonalisationOptionsContainer,
    VouchersContainer,
    GroupModerationContainer,
    CreateContentContainer,
    DashboardContainer,
    LoginContainer,
    MessagesContainer,
    PageNotFoundContainer,
    UsersContainer,
    ProfileContainer,
    QuestionsContainer,
    QuestionEditorContainer,
    QuestionnairesContainer,
    QuestionnaireEditorContainer,
    QuestionnaireResultsContainer,
    QuizzesContainer,
    QuizEditorContainer,
    QuizPreviewContainer,
    HealthJourneysContainer,
    HealthJourneyEditorContainer,
    HealthDataExportsContainer
} from './config/routes';

export default class AppRouter extends Component {
    static propTypes = {
        isAuthed: PropTypes.bool.isRequired
    };

    shouldComponentUpdate(nextProps) {
        const { isAuthed } = this.props;

        if (isAuthed !== nextProps.isAuthed) {
            return true;
        }

        return false;
    }

    render() {
        const { isAuthed } = this.props;

        return (
            <Suspense fallback={<AppLoading />}>
                <Switch>
                    <UnauthedRoute path={ROUTES.LOGIN} exact={true} component={LoginContainer} isAuthed={isAuthed} />

                    <AuthedRoute path={ROUTES.HOME} exact={true} component={DashboardContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.USERS} exact={true} component={UsersContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.MESSAGES} exact={true} component={MessagesContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.CREATE_ARTICLE} exact={true} component={CreateContentContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.CREATE_PODCAST} exact={true} component={CreateContentContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.CREATE_VIDEO} exact={true} component={CreateContentContainer} isAuthed={isAuthed} />

                    <AuthedRoute path={ROUTES.CONTENT_LIST} exact={true} component={ContentListContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.PERSONALISATION_OPTIONS} exact={true} component={PersonalisationOptionsContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.VOUCHERS} exact={true} component={VouchersContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.GROUP_MODERATION} exact={true} component={GroupModerationContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.DASHBOARD} exact={true} component={DashboardContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.PROFILE} exact={true} component={ProfileContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.QUESTION_NEW} exact={true} component={QuestionEditorContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.QUESTION_EDITOR} exact={true} component={QuestionEditorContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.QUESTIONS} exact={true} component={QuestionsContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.QUESTIONNAIRE_RESULTS} exact={true} component={QuestionnaireResultsContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.QUESTIONNAIRE_EDITOR} exact={true} component={QuestionnaireEditorContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.QUESTIONNAIRES} exact={true} component={QuestionnairesContainer} isAuthed={isAuthed} />

                    <AuthedRoute path={ROUTES.QUIZ_PREVIEW} exact={true} component={QuizPreviewContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.QUIZ_VERSION} exact={true} component={QuizEditorContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.QUIZ_EDITOR} exact={true} component={QuizEditorContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.QUIZZES} exact={true} component={QuizzesContainer} isAuthed={isAuthed} />

                    <AuthedRoute path={ROUTES.HEALTH_JOURNEY_VERSION} exact={true} component={HealthJourneyEditorContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.HEALTH_JOURNEY_EDITOR} exact={true} component={HealthJourneyEditorContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.HEALTH_DATA_EXPORTS} exact={true} component={HealthDataExportsContainer} isAuthed={isAuthed} />
                    <AuthedRoute path={ROUTES.HEALTH_JOURNEYS} exact={true} component={HealthJourneysContainer} isAuthed={isAuthed} />

                    <Route component={PageNotFoundContainer} />
                </Switch>
            </Suspense>
        );
    }
}
